import { Link } from 'react-router-dom';
import type { Title } from '@/mocks/titles';
import RatingBadge from '@/components/base/RatingBadge';

interface TitleCardProps {
  item: Title;
}

export function TypeTag({ type }: { type: Title['type'] }) {
  const isMovie = type === 'movie';
  return (
    <span
      className={`inline-flex items-center rounded-md px-1.5 py-0.5 text-[11px] font-medium ${
        isMovie ? 'bg-secondary-100 text-secondary-900' : 'bg-primary-100 text-primary-800'
      }`}
    >
      {isMovie ? '电影' : '电视剧'}
    </span>
  );
}

export default function TitleCard({ item }: TitleCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
      title={`${item.title} - ${item.genres.join('/')}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title}海报`}
          title={`${item.title} ${item.type === 'movie' ? '电影' : '电视剧'}在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2">
          <RatingBadge rating={item.rating} size="sm" />
        </div>
        <div className="absolute top-2 right-2">
          <TypeTag type={item.type} />
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-sm text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
          {item.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-600">
          <span>{item.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{item.region}</span>
        </div>
        <p className="mt-1.5 text-xs text-foreground-600 truncate">{item.genres.join(' / ')}</p>
      </div>
    </Link>
  );
}